
export function HideLoader(triggerAction: string) {
  return (Class: Function) => {
    Object.defineProperty(Class.prototype, 'triggerAction', {
      value: triggerAction
    });
  };
}

export function ShowLoader() {
  return (Class: Function) => {
    Object.defineProperty(Class.prototype, 'showLoader', {
      value: true
    });
  };
}
